import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const RestoreIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M5.94321 14.5762V7.55629C5.94321 7.29139 6.20811 7.02649 6.47301 7.02649H9.12201C9.25446 7.02649 9.51936 7.02649 9.51936 7.29139L10.0492 8.08609H14.1551C14.42 8.08609 14.6849 8.351 14.6849 8.6159V9.80795"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M14.42 14.9735H6.20813C5.94323 14.9735 5.81078 14.7086 5.94323 14.5762L7.13528 10.2053C7.13528 9.94039 7.53263 9.80795 7.66508 9.80795H15.877C16.1419 9.80795 16.2744 10.0728 16.1419 10.2053L14.9498 14.5762C14.9498 14.8411 14.5525 14.9735 14.42 14.9735Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M18.526 1.86093V3.84768C18.526 4.11258 18.2611 4.37748 17.9962 4.37748H16.0095"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M3.4267 20.0066V18.0199C3.4267 17.755 3.6916 17.4901 3.9565 17.4901H5.94325"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M2.36708 16.1656C0.115421 12.3245 0.645223 7.29139 3.95648 3.98013C7.92999 0.00662243 14.2876 0.00662243 18.2611 3.98013"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M19.8505 5.96689C22.1022 9.80795 21.4399 14.8411 18.2611 18.0199C14.2876 21.9934 7.92999 21.9934 3.95648 18.0199"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
    </svg>
  </CircledIcon>
);
